import React, { FC, useCallback } from "react";
import F7 from "../../../utils/F7";
import config from "../../../config";
import gps from "../../../utils/gps";
import { useNavigate, useLocation } from "react-router-dom";
import usePermissions from "../../../hooks/usePermissions";
import { useMap } from "../../../App";

const Topbar: FC = () => {
  const map = useMap()!;
  const activateGeolocation = useCallback(() => {
    sessionStorage.setItem("warningGeolocation", "1");
    sessionStorage.setItem("warningAccepted", "true");
    gps.toggle(map);
  }, [map]);
  const inactivateGeolocation = useCallback(() => {
    sessionStorage.setItem("warningGeolocation", "2");
    gps.toggle(map);
  }, [map]);

  const onLocationClick = useCallback(() => {
    if (!config.isApp) {
      if (!sessionStorage.getItem("disableGeolocation") || sessionStorage.getItem("disableGeolocation") !== "true") {
        if (sessionStorage.getItem("warningGeolocation") === "0" && sessionStorage.getItem("warningAccepted") === "false") {
          F7.confirm(
            "",
            "You are currently using the WEB-browser and accurate Geolocation may not be available. Geolocation is inactive, do you want to activate it?",
            () => {
              activateGeolocation();
            }
          );
        } else if (sessionStorage.getItem("warningGeolocation") === "1" && sessionStorage.getItem("warningAccepted") === "true") {
          inactivateGeolocation();
        } else if (sessionStorage.getItem("warningGeolocation") === "2" && sessionStorage.getItem("warningAccepted") === "true") {
          activateGeolocation();
        } else {
          gps.toggle(map);
        }
      }
      return;
    } else {
      gps.toggle(map);
    }

    if (!("geolocation" in navigator)) {
      F7.alert("Turn on geolocation and try again", "Geolocation is not available");
    }
  }, [activateGeolocation, inactivateGeolocation, map]);

  const navigate = useNavigate();
  const location = useLocation();
  const onInventoryClick = useCallback(() => {
    navigate(`../`);
  }, [navigate]);
  const onListClick = useCallback(() => {
    navigate(location.pathname.endsWith("/list") ? "" : "list");
  }, [navigate, location]);
  const onMenuClick = useCallback(() => {
    F7.openPanel("left");
  }, []);
  const onAddGeomClick = useCallback(() => {
    navigate("o/new");
  }, [navigate]);

  const { canAddGeometry } = usePermissions();

  const initialTopbarButtons = [
    {
      id: "menu",
      icon: "fa fa-bars",
      callback: onMenuClick,
    },
    {
      id: "calendar",
      icon: "fa fa-folder-open",
      callback: onInventoryClick,
    },
    {
      id: "addgeom",
      icon: "fa fa-map-marker",
      callback: onAddGeomClick,
    },
    {
      id: "loc",
      icon: "fa fa-location-arrow",
      callback: onLocationClick,
    },
    {
      id: "list",
      icon: "fa fa-table",
      callback: onListClick,
    },
  ];
  return (
    <nav className="row topbar">
      {initialTopbarButtons.map((button, index) => (
        <div
          key={index}
          onClick={button.callback}
          className={
            button.id === "loc" && sessionStorage.getItem("disableGeolocation") === "true"
              ? "col-20 li li-disabled"
              : button.id === "addgeom" && !canAddGeometry
              ? "col-20 li li-hidden"
              : "col-20 li"
          }
        >
          <i className={button.icon + " li-icon"} />
        </div>
      ))}
    </nav>
  );
};

export default Topbar;
